"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchainEnd = void 0;
var EchainEnd;
(function (EchainEnd) {
    EchainEnd["movingEnd"] = "movingEnd";
    EchainEnd["fixedEnd"] = "fixedEnd";
})(EchainEnd = exports.EchainEnd || (exports.EchainEnd = {}));
//# sourceMappingURL=EchainEnd.js.map